var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content pb-0" },
    [
      _c(
        "Titlebar",
        {
          attrs: {
            incrustation: "fa-bullhorn",
            isLoading:
              _vm.viewState === "INITIAL" || _vm.viewState === "LOADING",
            backPath: _vm.backPath,
          },
        },
        [
          _c("h1", [
            _vm._v(
              _vm._s(
                _vm.viewState === "SUCCESS" && !!_vm.rmData.current
                  ? _vm.rmData.current.name ||
                      _vm.$t("remoteMonitoring.procedures.titles.new")
                  : _vm.$t("remoteMonitoring.titles.manager")
              )
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _c("div", { staticClass: "alert alert-info mb-4" }, [
            _vm._v(_vm._s(_vm.$t("remoteMonitoring.form.info"))),
          ]),
          _vm._v(" "),
          _vm.viewState === "INITIAL" || _vm.viewState === "LOADING"
            ? _c("UiSpinner")
            : _vm._e(),
          _vm._v(" "),
          _vm.viewState === "SUCCESS"
            ? _c(
                "section",
                [
                  _vm.rmData.current.status !== "waiting" && _vm.canEdit
                    ? _c("MonitoringForm", {
                        model: {
                          value: _vm.rmData.current,
                          callback: function ($$v) {
                            _vm.$set(_vm.rmData, "current", $$v)
                          },
                          expression: "rmData.current",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.canEdit
                    ? _c("p", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("module.forbidden")) +
                            "\n      "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-end gap-3 mt-4",
            },
            [
              _c(
                "UiButton2",
                {
                  directives: [
                    {
                      name: "can",
                      rawName: "v-can",
                      value: "beepiz-browse-remotemonitoring",
                      expression: "'beepiz-browse-remotemonitoring'",
                    },
                  ],
                  staticClass: "btn-lg",
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.goToPreviousPage()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("global.cancel")) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "UiButton2",
                {
                  directives: [
                    {
                      name: "can",
                      rawName: "v-can",
                      value: "beepiz-edit-remotemonitoring",
                      expression: "'beepiz-edit-remotemonitoring'",
                    },
                  ],
                  staticClass: "btn-brand btn-lg",
                  attrs: { disabled: _vm.isSaveRmButtonDisabled() },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleSaveRmButton()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("global.save")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }